import { IonTextarea } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { notesContainerService } from "./EmsNotesContainer.service";
import "./EmsNotesContainer.scss";
import InfiniteScroll from "react-infinite-scroll-component";
import _ from "lodash";
import Loader from "../../../components/Shared/Loader/Loader";
import { utilService } from "../../../services/utilService";
import NotesCard from "./NotesCard/NotesCard";
interface ContainerProps {
  isFromCaseDetails?: any;
  patientGuid?: any;
  siteGuid?: any;
  isEMT?: any;
  emsNetworkCode?: any;
  adjustMessageSection?: any;
}
const EMSNotesContainer: React.FC<ContainerProps> = (props) => {
  const [textData, setTextData]: any = useState("");
  const [isLoaderActive, setLoaderStatus] = useState(true);
  const [pageNo, setPageNo]: [number, Function] = useState(1);
  const [notesNextValue, setNotesNextValue]: any = useState("");
  var [notesContainerData, setNotesContainerData]: any = useState([]);

  useEffect(() => {
    getNotesContainerListDetails();
    // The interval was never cleared: it kept polling after the component was
    // gone, and every remount started another one on top.
    const interval = setInterval(() => {
      getNotesContainerListDetails();
    }, 45000);
    return () => clearInterval(interval);
  }, []);

  async function getNotesContainerListDetails(page: number = 1) {
    setLoaderStatus(true);
    const params: any = {
      reg_code: utilService.getNetwork(),
      is_ems: false,
      user_guid: utilService.getLoggedUserGuid(),
      patient_guid: props.patientGuid,
      site_guid: props.siteGuid,
    };

    const respNotesContainerResult: any =
      await notesContainerService.getNotesContainerList(params);
    if (
      respNotesContainerResult.isSuccess &&
      respNotesContainerResult.displayNotesContainer.length
    ) {
      setNotesNextValue(respNotesContainerResult.displayNotesContainer[0].next);
      if (pageNo === 1) {
        setNotesContainerData(
          _.cloneDeep(respNotesContainerResult?.displayNotesContainer[0].data)
        );
      } else {
        setNotesContainerData([
          ...notesContainerData,
          ...respNotesContainerResult?.displayNotesContainer[0].data,
        ]);
      }
      // setPageNo(pageNo + 1);
    } else {
      notesContainerService.handleErrorResponse();
    }

    setLoaderStatus(false);
  }

  const addNotes = () => {
    const addParams: any = {
      reg_code: utilService.getNetwork(),
      is_ems: checkEMS(),
      user_guid: utilService.getLoggedUserGuid(),
      note: textData,
      patient_guid: props.patientGuid,
      site_guid: props.siteGuid,
      ems_network_code: props.emsNetworkCode,
    };

    getNotesCardListDetails(addParams);
  };

  async function getNotesCardListDetails(addParams: any) {
    setLoaderStatus(true);
    const respNotesCardResult: any =
      await notesContainerService.addNotesCardList(addParams);
    if (respNotesCardResult.isSuccess) {
      getNotesContainerListDetails();
      setTextData("");
    } else {
      notesContainerService.handleErrorResponse();
    }

    setLoaderStatus(false);
  }

  const isNoteSubmitted = () => {
    if (notesContainerData) {
      if (notesContainerData.length > 1 && notesContainerData[0].guid) {
        return true;
      } else {
        return false;
      }
    }
  };

  const checkEMS = () => {
    if (props.isEMT) {
      return true;
    } else {
      return false;
    }
  };

  const onScroll = () => {
    if (!_.isEmpty(notesNextValue)) {
      setPageNo(pageNo + 1);
      getNotesContainerListDetails(pageNo + 1);
    }
  };

  return (
    <div className="ems-notes-container">
      <div className="sboard-notes-wrapper">
        <div className="notes-header-wrapper">
          <h6 className="patient-details">Messages :</h6>
        </div>
        <div className="text-area-wrapper">
          <IonTextarea
            className="text-area-wrap"
            value={textData}
            onIonChange={(event) => setTextData(event.detail.value!)}
            maxlength={300}
            placeholder="Type your message here..."
          ></IonTextarea>
          <span className="characterWarning">
            {300 - textData?.length} characters left.
          </span>
          <div
            className="icon-send note-send-button"
            onClick={() => addNotes()}
          ></div>
        </div>

        <div className="prev-notes-container">
          {notesContainerData && (
            <div
              className={`notes-list-div ${
                props.isFromCaseDetails ? "adjust-ems-note-height" : ""
              }`}
            >
              {isLoaderActive && (
                <div className="loader-container">
                  <Loader></Loader>
                </div>
              )}

              <InfiniteScroll
                dataLength={notesContainerData.length}
                className={`emg-message-section ${
                  props.isEMT ? "ems-message-section" : ""
                }`}
                next={() => onScroll()}
                hasMore={true}
                loader={<div></div>}
              >
                <div className="inner-grid image-wrapper">
                  <div className="heading">
                    {notesContainerData && notesContainerData.length > 0
                      ? notesContainerData.map((item: any, index: number) => {
                          return (
                            <NotesCard key={index} notesData={item}></NotesCard>
                          );
                        })
                      : [
                          !isLoaderActive && (
                            <div className="no-message-label" key={""}>
                              No messages.
                            </div>
                          ),
                        ]}
                  </div>
                </div>
              </InfiniteScroll>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EMSNotesContainer;
